import httpStore from "@/api/httpStore.js";

export const getWarehouses = (departamentoId = null) => {
  const query = departamentoId ? `?departamento_id=${departamentoId}` : "";
  return httpStore
    .get(`warehouse/depositos${query}`)
    .then(res => res.data)
    .catch(error => {
      console.error("Error getting warehouses", error);
      return [];
    });
};
